import { createSafeContext } from '@mantine/core';

import { ActionMenuContext } from './actions.types';

const [ActionMenuProvider, useActionMenuContext] = createSafeContext<ActionMenuContext>(
  'ActionMenu Provider component was not found in tree'
);
export { ActionMenuProvider, useActionMenuContext };
